// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  position: relative;
}

.item {
  position: relative;
  height: 100%;
}
.item h3, .item p {
  margin: 0;
  padding: 0;
}
.item a {
  text-decoration: none;
}
.item__content {
  padding: var(--spacing-half);
  border-radius: var(--spacing-half);
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.item__content .image {
  position: relative;
  overflow: hidden;
  aspect-ratio: 16/9;
  background: var(--ion-background-secondary-color);
  border-radius: var(--spacing-quarter);
}
.item__content .image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.item__content .image .tickets {
  display: flex;
  align-items: center;
  gap: var(--spacing-quarter);
  padding: var(--spacing-quarter);
  position: relative;
  top: 0;
  width: 100%;
}
.item__content .image .tickets span {
  font-size: var(--font-size-nano);
}
.item__content .image .tickets__warning {
  background: var(--ion-color-warning);
  color: var(--ion-color-warning-contrast);
}
.item__content .details {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.item__content .details .location {
  margin: calc(var(--spacing) * 0.5) 0 0 0;
  font-weight: bold;
}
.item__content .details .title {
  color: var(--color-primary);
}
.item__content .details .owner {
  display: block;
  margin-bottom: calc(var(--spacing) * 0.5);
  font-weight: bold;
}
.item__content .details .owner span {
  margin-right: calc(var(--spacing) * 0.5);
}
.item__content .details .excerpt {
  overflow: hidden;
  max-height: 0 !important;
  opacity: 0;
  margin: 0;
}
.item__content .info {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.item__content .info small {
  font-weight: normal;
}
.item__content .info .price,
.item__content .info .ticket_types {
  font-weight: bold;
}
.item__content .info .price small,
.item__content .info .ticket_types small {
  display: block;
}
.item__content .info .price {
  color: var(--color-primary);
}
.item__content .info .ticket_types {
  text-align: right;
  opacity: 0;
}
.item:hover .item__content {
  transition: all 0.25s ease-in-out;
  transform: scale(1.05);
  position: absolute;
  z-index: 999;
  height: auto;
  background: var(--ion-background-color);
  box-shadow: 0 0 calc(var(--spacing) * 0.5) 0 rgba(0, 0, 0, 0.2);
}
.item:hover .item__content .excerpt {
  transition: all 0.15s ease-in-out;
  max-height: none !important;
  opacity: 1;
  margin: calc(var(--spacing) * 0.25) 0 calc(var(--spacing) * 0.5) 0;
}
.item:hover .item__content .ticket_types {
  transition: opacity 0.25s ease-in-out;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/general-components/filter-search-item/filter-search-item.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,kBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,YAAA;AACJ;AACI;EACI,SAAA;EACA,UAAA;AACR;AAEI;EACI,qBAAA;AAAR;AAGI;EACI,4BAAA;EACA,kCAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AADR;AAGQ;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iDAAA;EACA,qCAAA;AADZ;AAGY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AADhB;AAIY;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,+BAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AAFhB;AAIgB;EACI,gCAAA;AAFpB;AAKgB;EACI,oCAAA;EACA,wCAAA;AAHpB;AAQQ;EACI,YAAA;EACA,aAAA;EACA,sBAAA;AANZ;AAQY;EACI,wCAAA;EACA,iBAAA;AANhB;AASY;EACI,2BAAA;AAPhB;AAUY;EACI,cAAA;EACA,yCAAA;EACA,iBAAA;AARhB;AAUgB;EACI,wCAAA;AARpB;AAYY;EACI,gBAAA;EACA,wBAAA;EACA,UAAA;EACA,SAAA;AAVhB;AAcQ;EACI,aAAA;EACA,8BAAA;EACA,qBAAA;AAZZ;AAcY;EACI,mBAAA;AAZhB;AAeY;;EAEI,iBAAA;AAbhB;AAegB;;EACI,cAAA;AAZpB;AAgBY;EACI,2BAAA;AAdhB;AAiBY;EACI,iBAAA;EACA,UAAA;AAfhB;AAqBQ;EACI,iCAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EAEA,uCAAA;EACA,+DAAA;AApBZ;AAsBY;EACI,iCAAA;EACA,2BAAA;EACA,UAAA;EACA,kEAAA;AApBhB;AAuBY;EACI,qCAAA;EACA,UAAA;AArBhB","sourcesContent":[":host {\n    display: block;\n    position: relative;\n}\n\n.item {\n    position: relative;\n    height: 100%;\n    \n    h3, p {\n        margin: 0;\n        padding: 0;\n    }\n    \n    a {\n        text-decoration: none;\n    }\n    \n    &__content {\n        padding: var(--spacing-half);\n        border-radius: var(--spacing-half);\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        height: 100%;\n        box-sizing: border-box;\n\n        .image {\n            position: relative;\n            overflow: hidden;\n            aspect-ratio: 16/9;\n            background: var(--ion-background-secondary-color);\n            border-radius: var(--spacing-quarter);\n\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n            }\n\n            .tickets {\n                display: flex;\n                align-items: center;\n                gap: var(--spacing-quarter);\n                padding: var(--spacing-quarter);\n                position: relative;\n                top: 0;\n                width: 100%;\n\n                span {\n                    font-size: var(--font-size-nano);\n                }\n\n                &__warning {\n                    background: var(--ion-color-warning);\n                    color: var(--ion-color-warning-contrast);\n                }\n            }\n        }\n\n        .details {\n            flex-grow: 1;   \n            display: flex;\n            flex-direction: column;\n\n            .location {\n                margin: calc(var(--spacing) * .5) 0  0 0;\n                font-weight: bold;\n            }\n\n            .title {\n                color: var(--color-primary);\n            }\n\n            .owner {\n                display: block;\n                margin-bottom: calc(var(--spacing) * .5);\n                font-weight: bold;\n\n                span {\n                    margin-right: calc(var(--spacing) * .5);\n                }\n            }\n\n            .excerpt {\n                overflow: hidden;\n                max-height: 0 !important;\n                opacity: 0;\n                margin: 0;\n            }\n        }\n\n        .info {\n            display: flex;\n            justify-content: space-between;\n            align-items: flex-end;\n\n            small {\n                font-weight: normal;\n            }\n            \n            .price,\n            .ticket_types {\n                font-weight: bold;\n                \n                small {\n                    display: block;\n                }\n            }\n            \n            .price {\n                color: var(--color-primary);\n            }\n            \n            .ticket_types {\n                text-align: right;\n                opacity: 0;\n            }\n        }\n    }\n\n    &:hover {\n        .item__content {\n            transition: all .25s ease-in-out;\n            transform: scale(1.05);\n            position: absolute;\n            z-index: 999;\n            height: auto;\n\n            background: var(--ion-background-color);\n            box-shadow: 0 0 calc(var(--spacing) * .5) 0 rgba(0,0,0,0.2);\n            \n            .excerpt {\n                transition: all .15s ease-in-out;\n                max-height: none !important;\n                opacity: 1;\n                margin: calc(var(--spacing) * .25) 0 calc(var(--spacing) * .5) 0;\n            }\n            \n            .ticket_types {\n                transition: opacity .25s ease-in-out;\n                opacity: 1;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
